(ns dre.modals.surveys.views
  (:require
   ["antd" :refer [Radio]]
   [clojure.string :as str]
   [dre.app.events :as app-events]
   [dre.components.inputs :refer [input-text input-textarea]]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.form :refer [form form-item]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.i18n.views :refer [tr]] 
   [dre.modals.surveys.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def departments
  ["Analytics/Biostats"
   "Clinical Development"
   "Clinical Operations"
   "Commercial"
   "HEOR/Market Access"
   "IT"
   "Library and Publications"
   "Medical Affairs"
   "Procurement"
   "PV/Safety/Epi"
   "Regulatory Affairs"
   "Research and Development"
   "RWE"
   "Other"])

(defn survey-dept
  [dept-data]
  (let [update-dept (fn [v] (let [vu (if (= v "Other") "" v)]
                              (rf/dispatch [::events/update-data :department vu])))
        other? (or (= dept-data "Other") (and (not (some #(= dept-data %) departments)) (not (nil? dept-data))))]
    [:<>
     [form-item
      {:label (r/as-element [:b [tr "1. In order to maximize your user experience, please select the appropriate department:*"]])}
      [dropdown
       {:alignment :left
        :anchor
        [:button
         {:class (bem/bm :button [:light :small])}
         (cond 
           other? "Other"
           (not (nil? dept-data)) dept-data
           :else "Choose")
         [icoinor-icon :nav-arrow-down]]
        :content
        [dropdown-list
         (for [v departments]
           ^{:key v}
           [:a
            {:on-click #(update-dept v)}
            v])]}]]
     (when other?
       [form-item
        {:label [tr "Please specify"]}
        [input-text
         {:on-change #(update-dept  (-> % .-target .-value))
          :value dept-data}]])]))

(defn survey-raiting
  [raiting-data reason-data]
  (let [update-raiting (fn [v] (rf/dispatch [::events/update-data :rating v]))
        update-reason (fn [v] (rf/dispatch [::events/update-data :reason v]))]
    [:<>
     [form-item
      {:label (r/as-element [:b [tr "2. How likely are you to recommend Litetature Search to a colleague or co-worker?"] " " [tr "Please rate on a scale of zero to ten."] "*"])}
      [:> Radio.Group {:value raiting-data :on-change #(update-raiting  (-> % .-target .-value))}
       (doall
        (for [v (range 0 11)]
          ^{:key (str "survey-recommend" v)}
          [:> Radio.Button {:value v} v]))]]
     (when raiting-data
       [form-item
        {:label (r/as-element [:b [tr "3. Please share why you selected"] " " raiting-data "."])}
        [input-textarea
         {:on-change #(update-reason  (-> % .-target .-value))
          :value reason-data}]])]))

(defn content
  []
  (let [data @(rf/subscribe [::events/data])
        user @(rf/subscribe [::app-events/user])
        survey-name (get-in user [:survey-names :docsearch])]
    [:div
     [form
      {:layout "vertical"}
      [:<>
       [survey-dept (:department data)]
       [survey-raiting (:rating data) (:reason data)]]]]))

(defn view
  []
  (fn []
    (let [data @(rf/subscribe [::events/data])
          disabled? (or (not (number? (:rating data)))
                        (str/blank? (:department data))
                        (nil? (:department data)))
          user @(rf/subscribe [::app-events/user])
          survey-name (get-in user [:survey-names :docsearch])]
      [modal-window
       {:title "Please answer the following questions"
        :content content
        :submit? true
        :submit-text [tr "Submit"]
        :submit-disabled? disabled?
        :on-submit (fn [e]
                     (rf/dispatch [::events/clear])
                     (rf/dispatch [::events/submit survey-name]))
        :on-close-fx ::events/dismiss}])))